import * as React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ColorPicker from './ColorPicker';
import {Action} from '../../../system/buttons';
import Ranges from '../../../system/ranges';
import '../../../App.css';
import {FontManager} from './FontManager';
import {PremiumWrapperOverlay} from '../../PremiumWrapperOverlay';

export default class BpmEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.configuration,
      visibilityDraft: true,
      rangeColorDraft: '#ff0000',
      showRangePicker: false,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState !== this.state) {
      this.props.onUpdate({
        alignment: this.state.alignment,
        font: this.state.font,
        backgroundColor: this.state.backgroundColor,
        ranges: this.state.ranges,
        fontUrl: this.state.fontUrl,
      });
    }
  }

  render() {
    return (
      <>
        <h4>Configured ranges</h4>
        <PremiumWrapperOverlay
          bi={{
            from: 'widget_edit_premium_update',
            id: this.props.id,
          }}
          disabled={!this.props.premiumUpdate}
        >
          <Ranges
            ranges={this.state.ranges}
            onRangesChange={(ranges) => this.setState({ranges})}
            defaultRange={{
              from: 60,
              to: 90,
              color: '#11a2b1ff',
            }}
            header={
              <Col md={3}>
                <Form inline>
                  <Col>Color</Col>
                </Form>
              </Col>
            }
            rangeConfiguration={(range, onRangeChange) => (
              <Col md={3} key={range.from}>
                <Form inline>
                  <ColorPicker
                    color={range.color}
                    onChangeComplete={(color) =>
                      onRangeChange({
                        ...range,
                        color,
                      })
                    }
                  />
                </Form>
              </Col>
            )}
          />
          <Row>&nbsp;</Row>

          <FontManager
            font={this.state.font}
            fontUrl={this.state.fontUrl}
            onChange={(font) => this.setState({font})}
          />

          <Form.Group as={Row}>
            <Form.Label column sm="2">
              Alignment
            </Form.Label>
            <Col sm="3">
              <Form.Control
                as="select"
                value={this.state.alignment}
                onChange={(e) => this.setState({alignment: e.target.value})}
              >
                <option key={1}>left</option>
                <option key={2}>center</option>
                <option key={3}>right</option>
              </Form.Control>
            </Col>
          </Form.Group>
        </PremiumWrapperOverlay>

        <Action
          onClick={() =>
            this.props.onSave({
              alignment: this.state.alignment,
              font: this.state.font,
              backgroundColor: this.state.backgroundColor,
              ranges: this.state.ranges,
              fontUrl: this.state.fontUrl,
            })
          }
        >
          Save settings
        </Action>
      </>
    );
  }
}
